import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { AutorunComponent } from '@myshared/autorun.component';
import { I18NextService } from 'angular-i18next';
import {TariffService} from '../../tariff.service';
import {autorun} from 'mobx';
import {Tariff, tariffFlatNames} from '../../tariff.model';
import {Model} from '../../../app.model';
import {Subscription} from "../../../subscription/subscription.model";
import {tariffNameTranslationKey} from "@myshared/utils";

@Component({
    selector: 'app-tariff-select',
    templateUrl: './tariff-select.component.html',
    standalone: false
})
export class TariffSelectComponent extends AutorunComponent {

    @Input() public currentPlan: string;
    @Input() public flatrates: Tariff[];

    @Input() subscription: Subscription;

    @Output()
    public back = new EventEmitter<number>();
    @Output()
    public selected = new EventEmitter<string>();

    constructor() {
        super();
    }

    public onBack() {
        this.back.emit();
    }

    public onTariffSelected(tariff: string) {
        this.selected.emit(tariff);
    }

    public getZoneTranslationKey(zoneName: string): string {
        return 'tariff_min_' + zoneName.replace('-', '_').toLowerCase();
    }

    public filteredFlatrates() {
        return this.flatrates.filter(l => l?.name !== "PC-ONE-TARIFF-FLAT-FULL").sort(this.compareNumbers); 
    }
    private compareNumbers(a: Tariff, b: Tariff) {
        return +a.listPrice - +b.listPrice;
    }

    public get isAbovePopularSelected() {
      return this.currentPlan === 'PC-ONE-TARIFF-FLAT-L' || this.currentPlan === 'PC-ONE-TARIFF-FLAT-XL';
    }

    public get countryTranslationCode() {
        return this.subscription.trunkEnvironment.trunkInformationTranslationCode;
    }
}
